export default __webpack_public_path__ + "static/media/vista-brochure.960c81af.pdf";